export default __webpack_public_path__ + "static/media/cover_5.216217d7.jpg";